import React, { useEffect } from "react";
import { Container, Typography, Paper, Box } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link } from "react-router-dom";

const DataAnalytics = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Box sx={{ display: "flex", flexDirection: "column", overflowX: "hidden" }}>
      <Paper
        elevation={0}
        sx={{
          backgroundImage: 'url("/assets/DataAnalytics/background.webp")',
          backgroundPosition: "center",
          backgroundSize: "cover",
          maxWidth: "100%",
          height: "480px",
          display: "flex",
          overflowX: "hidden",
          backgroundColor: "#000000",
        }}
      >
        <Container
          disableGutters
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            maxWidth: "lg",
            margin: "0 0 0 10%",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Orbitron",
              fontWeight: "800",
              fontSize: { xs: "18px", sm: "24px", md: "28px" }, // Font size for different screen sizes
              color: "#FFFFFF",
              lineHeight: "120%",
              letterSpacing: "2%",
              display: "flex",
              justifyContent: "flex-start",
              paddingBottom: "2%",
            }}
          >
            Insights Meet Innovation with Tecloq’s
          </Typography>

          <Typography
            sx={{
              fontFamily: "Orbitron",
              fontWeight: "800",
              fontSize: { xs: "36px", sm: "48px", md: "60px" }, // Font size for different screen sizes
              color: "#F005A2",
              lineHeight: "120%",
              letterSpacing: "2%",
              display: "flex",
              paddingBottom: "2%",
            }}
          >
            Data Analytics Services
          </Typography>

          <Typography
            sx={{
              fontFamily: "Orbitron",
              fontWeight: "800",
              fontSize: { xs: "18px", sm: "20px", md: "24px" }, // Font size for different screen sizes
              color: "#FFFFFF",
              lineHeight: "120%",
              letterSpacing: "2%",
              display: "flex",
              justifyContent: "flex-start",
              paddingBottom: "5%",
              padding: { xs: "10px", sm: "15px", md: "20px" },
              marginBottom: { xs: "20px" }, // Padding for different screen sizes
            }}
          >
            Your Data, Our Analytics, Limitless Potential
          </Typography>
          <Link
            to="/clientForm"
            style={{
              display: "flex",
              width: "150.84px",
              height: "52.23px",
              backgroundColor: "#F005A2",
              borderRadius: "45.25px",
              opacity: "100%",
              alignItems: "center",
              justifyContent: "center",
              padding: "0 2% 0 2%",
              textDecoration: "none",
              color: "inherit",
            }}
          >
            <div
              style={{
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontSize: "18px",
                letterSpacing: "8%",
                fontWeight: "700",
              }}
            >
              Contact Us
            </div>
            <div
              className="submitBtn__Arrow"
              style={{
                width: "32.84px",
                height: "32.23px",
                backgroundColor: "#FFFFFF",
                borderRadius: "45.25px",
                opacity: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginLeft: "7%",
              }}
            >
              <ArrowForwardIcon></ArrowForwardIcon>
            </div>
          </Link>
        </Container>
      </Paper>

      <Box sx={{ textAlign: "center", marginTop: "6%" }}>
        <Box
          sx={{
            maxWidth: "100% !important",
            height: "auto",
            marginTop: "6%",
            paddingX: { xs: "5%", sm: "10%", md: "0" },
          }}
        >
          <Typography
            sx={{
              fontFamily: "Orbitron",
              fontWeight: "800",
              fontSize: { xs: "24px", md: "25px" },
              color: "#000000",
              lineHeight: "120%",
              letterSpacing: "2%",
              display: "flex",
              justifyContent: "center",
              paddingBottom: "1%",
            }}
          >
            Navigate Insights with Precision through Tecloq’s Data Analytics
          </Typography>
          <Typography
            sx={{
              fontFamily: "Inter",
              fontWeight: "lighter",
              fontSize: { xs: "14px", sm: "14px", md: "15px" },
              color: "#000000",
              display: "flex",
              justifyContent: "center",
              margin: {
                xs: "3% 5%",
                sm: "2% 10%",
                md: "1% 13% 2% 13%",
              },
              textAlign: "center",
            }}
          >
            Envision a continuous flow of insights empowering your business
            decisions. That’s what the convergence of data, analytics, and AI
            does for you, forging a gateway to uncharted horizons of potential.
            Tecloq presents a comprehensive array of Data Analytics Services,
            elevating raw data into actionable insights that drive your
            decision-making. From data visualization consulting to business
            intelligence services, we harness advanced tools like-
          </Typography>
        </Box>
        <Box
          component="img"
          src="/assets/DataAnalytics/technical.png"
          alt="technicals"
          loading="lazy"
          sx={{
            width: {
              xs: "60%", // For extra small screens (mobile)
              sm: "40%", // For small screens (tablets)
              md: "25%", // For medium and larger screens (desktops)
            },
            height: "auto",
            marginTop: "2%",
            maxWidth: "100%",
          }}
        />
      </Box>

      <Box
        sx={{
          maxWidth: "100% !important",
          height: "auto",
          marginTop: "8%",
          textAlign: "center",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: {
              xs: "24px", // Smaller font size on mobile
              sm: "30px", // Medium font size on tablets
              md: "40px", // Larger font size on desktop
            },
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            paddingBottom: "1%",
            justifyContent: "center",
          }}
        >
          Our Data Analytics Services
        </Typography>
        <Typography
          sx={{
            fontFamily: "Inter",
            fontWeight: "lighter",
            fontSize: {
              xs: "14px", // Smaller font size on mobile
              sm: "16px", // Medium font size on tablets
              md: "20px", // Larger font size on desktop
            },
            color: "#000000",
            display: "flex",
            padding: {
              xs: "2% 5%", // Less padding on mobile
              sm: "2% 10%", // Moderate padding on tablets
              md: "2% 20%", // Larger padding on desktop
            },
            textAlign: "center",
          }}
        >
          Tecloq drives business intelligence through our comprehensive range of
          data analytics services. From envisioning data and analytics
          strategies to implementing cutting-edge solutions, we propel your
          organization towards data-driven excellence.
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexWrap: { xs: "wrap", md: "wrap" },
          flexDirection: { xs: "row" },
          gap: {
            xs: "10px", // Less gap on smaller screens
            sm: "15px", // Moderate gap on tablets
            md: "20px", // Larger gap on desktops
          },
          "& > :not(style)": {
            m: 1,
            width: {
              xs: 150, // Smaller width on phones
              sm: 300, // Medium width on tablets
              md: 350, // Larger width on desktops
            },
            height: {
              xs: 120, // Smaller height on phones
              sm: 240, // Medium height on tablets
              md: 270, // Larger height on desktops
            },
          },
        }}
      >
        {[
          {
            img: "/assets/DataAnalytics/DA1.png",
            alt: "text analysis",
            title: "Data & Analytics",
            subtitle: "Consulting",
          },
          {
            img: "/assets/DataAnalytics/DA2.png",
            alt: "text analysis",
            title: "Data & Analytics",
            subtitle: "Implementation",
          },
          {
            img: "/assets/DataAnalytics/DA3.png",
            alt: "text analysis",
            title: "Data & Analytics",
            subtitle: "Modernization",
          },
          {
            img: "/assets/DataAnalytics/DA4.png",
            alt: "text analysis",
            title: "Industrialized",
            subtitle: "Solution",
          },
          {
            img: "/assets/DataAnalytics/DA5.png",
            alt: "text analysis",
            title: "Data Management",
            subtitle: "Services",
          },
        ].map((item, index) => (
          <Paper
            key={index}
            elevation={3}
            sx={{
              borderRadius: "5%",
              textAlign: "center",
              paddingBottom: "3%",
              alignContent: "center",
            }}
          >
            <Box
              component="img"
              src={item.img}
              alt={item.alt}
              loading="lazy"
              sx={{
                boxSizing: "border-box",
                width: {
                  xs: "50%", // Smaller image size on phones
                  sm: "55%", // Medium size on tablets
                  md: "60%", // Larger size on desktops
                },
                height: "auto",
                paddingTop: {
                  xs: "2%", // Smaller top padding on phones
                  sm: "8%", // Medium padding on tablets
                  md: "9%", // Larger padding on desktops
                },
              }}
            />
            <Typography
              sx={{
                fontFamily: "Inter",
                fontStyle: "normal",
                fontWeight: "700",
                fontSize: {
                  xs: "10px", // Smaller font size on phones
                  sm: "15px", // Medium font size on tablets
                  md: "16px", // Larger font size on desktops
                },
                lineHeight: "21px",
                alignItems: "center",
                textAlign: "center",
                color: "#000000",
                paddingTop: {
                  xs: "3%", // Smaller padding on phones
                  sm: "4%", // Medium padding on tablets
                  md: "5%", // Larger padding on desktops
                },
              }}
            >
              {item.title}
              <br />
              {item.subtitle}
            </Typography>
          </Paper>
        ))}
      </Box>

      <Box
      sx={{
        maxWidth: "100% !important",
        height: "auto",
        marginTop: { xs: "4%", sm: "5%", md: "6%" },
      }}
    >
      {/* Title Section */}
      <Typography
        sx={{
          fontFamily: "Orbitron",
          fontWeight: "800",
          fontSize: { xs: "24px", sm: "32px", md: "40px" },
          color: "#000000",
          lineHeight: "120%",
          letterSpacing: "2%",
          display: "flex",
          justifyContent: "center",
          paddingBottom: "1%",
        }}
      >
        The Tecloq Advantages
      </Typography>
      <Typography
        sx={{
          fontFamily: "Inter",
          fontWeight: "lighter",
          fontSize: { xs: "14px", sm: "16px", md: "20px" },
          color: "#000000",
          display: "flex",
          justifyContent: "center",
          margin: { xs: "2% 5%", sm: "2% 10%", md: "1% 15% 2% 15%" },
          textAlign: "center",
        }}
      >
        Choosing Tecloq as your Data Analytics Services partner means embracing a
        holistic approach to data-driven decision-making. We stand out for several
        reasons.
      </Typography>

      {/* Cards Section */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          gap: "3%",
          "& > :not(style)": {
            m: 1,
            width: { xs: "90%", sm: 370, md: 370 },
            height: { xs: "auto", md: 600 },
          },
        }}
      >
        {[
          {
            imgSrc: "/assets/DataAnalytics/TA1.png",
            title: "Expertise and Experience",
            description:
              "Our seasoned team of data scientists, developers, and consultants bring a wealth of knowledge and practical experience to the table, ensuring that your data is in capable hands.",
          },
          {
            imgSrc: "/assets/DataAnalytics/TA2.png",
            title: "Custom Solutions",
            description:
              "We understand that every business is unique. Our tailored Data Analytics Services are designed to align with your specific objectives and challenges, ensuring that you get precisely what you need.",
          },
          {
            imgSrc: "/assets/DataAnalytics/TA3.png",
            title: "Expertise in Latest Tools",
            description:
              "From AWS QuickSight to Looker and Microsoft Fabric, we leverage the latest technologies to provide you with the most powerful and effective data analytics solutions.",
          },
        ].map((card, index) => (
          <Paper
            key={index}
            elevation={3}
            sx={{
              borderRadius: "3%",
              textAlign: "center",
              border: "0.5px solid #FFC3EA",
              alignContent: "center",
              boxShadow: "0px -3px 17px rgba(240, 5, 162, 0.52)",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <img
              src={card.imgSrc}
              alt={`card-${index}`}
              loading="lazy"
              style={{
                width: "70%",
                height: "35%",
                padding: "15% 0px 10% 15%",
              }}
            />
            <Typography
              sx={{
                fontFamily: "Orbitron",
                lineHeight: "120%",
                fontSize: {xs:"22px", md:"28px"},
                fontStyle: "normal",
                fontWeight: "700",
                color: "#F005A2",
                letterSpacing: "2%",
              }}
            >
              {card.title}
            </Typography>
            <Typography
              sx={{
                fontFamily: "Inter",
                fontStyle: "normal",
                fontSize: {xs:"14px", md:"18px"},
                lineHeight: "auto",
                padding: "10% 10% 3% 10%",
              }}
            >
              {card.description}
            </Typography>
          </Paper>
        ))}
      </Box>
    </Box>
    </Box>
  );
};

export default DataAnalytics;
